import React from "react";
import styled from "styled-components";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { useNavigate } from "react-router-dom";
import { Button, ButtonWrapper, Container, HeadingTextcontainer, NftGridContainer, NftGridWrapper, NftNameText,NftCategory, NftNameHash, NftNameWrapper, NftNewArivalWrapper, PopularWeaponsContainer, Text, TextWrapper, ViewAllWrapper, ViewButton } from "../NftmarketGridStyledComponent";

const Root = styled.div``;
// const Container = styled.div`
//   position: relative;
// `;
// const PopularWeaponsContainer = styled.div`
//   position: relative;
//   padding: 50px 0px;
// `;
// const TextWrapper = styled.div`
// @media(max-width: 640px){
//   display: flex;
//     justify-content: flex-start;
//     align-items: flex-start;
//     text-align: start;
// }
// `;
// const Text = styled.text`
//   font-family: SweraDemo;
//   font-style: normal;
//   font-weight: 700;
//   font-size: 24px;
//   line-height: 32px;
//   display: flex;
//   align-items: center;
//   @media(max-width:640px){
//     font-size:20px;
//   }
// `;

// const ViewAllWrapper = styled.div``;
// const ViewButton = styled.button`
//   background: #203736;
//   border-radius: 30px;
//   font-size: 16px;
//   color: white;
//   padding: 12px 22px;
//   outline: none;
//   border: none;
//   cursor: pointer;
//   color:#88FEFE;
// `;

// const HeadingTextcontainer = styled.div`
//   display: flex;
//   justify-content: space-between;
//   align-items: center;
//   text-align: center;
//   margin: 40px 0;
// `;

// const NftGridContainer = styled.div`
  
// `;
// const NftGridWrapper = styled.div`
//   background: linear-gradient(
//     160.61deg,
//     rgba(255, 255, 255, 0.1) 0%,
//     rgba(255, 255, 255, 0.05) 101.7%
//   );
//   border-width: 2.5px 0px;
//   border-style: solid;
//   border-color: rgba(255, 255, 255, 0.4);
//   backdrop-filter: blur(17.915px);
//   border-radius: 30px;
// `;

// const NftNewArivalWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   align-items: center;
// `;
// const NftNewArival = styled.img`
//   width: 90%;
//   padding: 20px 0;
//   cursor: pointer;
// `;
// const NftNameWrapper = styled.div`
//   display: flex;
//   justify-content: flex-start;
//   text-align: start;
//   align-items: center;
//   width: 100%;
//   padding: 0 20px;
// `;
// const NftNameText = styled.text`
//   font-style: normal;
//   font-weight: 700;
//   font-size: 18px;
//   line-height: 22px;
//   text-transform: capitalize;
//   color: #ffffff;
//   @media(max-width:768px){
// font-size:16px;
//   }
// `;

const PriceText = styled.text`
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #8A8AA0;
    margin-bottom: 5px;
    text-align: start;
    margin: 0;
`;

const Pricevalue = styled.text`
  font-style: normal;
  font-weight: 700;
  font-size: 22px;
  line-height: 20px;
  color: #25a8c5;
  margin: 5px 0 0px 0;
  text-align: start;
`;

const PriceButtonContainer = styled.div`
  display: flex;
  margin: 20px 15px;
  justify-content: space-between;
  align-items: flex-end;
  text-align: center;
  @media(max-width: 768px){
    margin: 10px 17px 20px 17px;
  }
  @media(max-width: 1024px){
    margin: 10px 17px 20px 17px;
  }
`;
const PriceWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: baseline;
    line-height: 22px;
   ${(p)=>p.PriceText && `
      display: flex;
      justify-content: flex-end;
      align-items: flex-start;
    `}
    ${(p)=>p.OwnedBy && `
      display: flex;
      justify-content: flex-start;
      align-items: end;
    `}
`;
// const PriceText = styled.text``;
// const Pricevalue = styled.div`
//   font-style: normal;
//   font-weight: 700;
//   font-size: 18px;
//   line-height: 22px;
//   text-transform: capitalize;
//   color: #ffffff;
// `;
// const ButtonWrapper = styled.div``;
// const Button = styled.button`
//   background: #ffffff;
//   border-radius: 30px;
//   font-style: normal;
//   font-weight: 500;
//   font-size: 18px;
//   line-height: 20px;
//   text-align: center;
//   padding: 10px 20px;
//   color: #191919;
//   border: none;
//   outline: none;
//   cursor: pointer;
//   @media(max-width:1260px){
//     font-size:16px;
//    padding: 8px 15px;
//   }
// `;

const TrendingWeapons = ({oneSection}) => {
  var settings = {
    // dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
   
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        }
      },
      {
        breakpoint: 540,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      },
      
     ]

  };


  const navigation = useNavigate();
  return (
    <Root>
      <Container>
        <HeadingTextcontainer>
          <TextWrapper>
            <Text>Trending Weapons</Text>
          </TextWrapper>
          <ViewAllWrapper onClick={() => navigation("/nftcategories")}>
            <ViewButton>View All</ViewButton>
          </ViewAllWrapper>
        </HeadingTextcontainer>

        <NftGridContainer>
          <Slider {...settings}>
            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
            
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> StingRay Rifle </NftNameText>
                <NftNameHash> #1099 </NftNameHash>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 45.32 USD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory common>Common</NftCategory>
             
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Fangs of Fury </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 15.5 USD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory rare>Rare</NftCategory>
            
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Circuit Breaker </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 48MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
               
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Launcher </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 2.65MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
              
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Heavy </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 10MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>
          </Slider>
        </NftGridContainer>
      </Container>

      <PopularWeaponsContainer>
        <HeadingTextcontainer>
          <TextWrapper>
            <Text>Trending Melee </Text>
          </TextWrapper>
          <ViewAllWrapper onClick={() => navigation("/nftcategories")}>
            <ViewButton>View All</ViewButton>
          </ViewAllWrapper>
        </HeadingTextcontainer>

        <NftGridContainer>
          <Slider {...settings}>
          <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
              
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> StingRay Rifle </NftNameText>
                <NftNameHash> #1099 </NftNameHash>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 45.32 USD </Pricevalue>
                </PriceWrapper>
                {/* <PriceWrapper>
                    <PriceText OwnedBy> Owned By </PriceText>
                    <Pricevalue> Tyagi </Pricevalue>
                </PriceWrapper> */}
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory common>Common</NftCategory>
          
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Fangs of Fury </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 15.5 USD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory rare>Rare</NftCategory>
             
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Circuit Breaker </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 48MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
              
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Launcher </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 2.65MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
             
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Heavy </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 10MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>
          </Slider>
        </NftGridContainer>
      </PopularWeaponsContainer>

      <Container>
        <HeadingTextcontainer>
          <TextWrapper>
            <Text>Trending Character </Text>
          </TextWrapper>
          <ViewAllWrapper onClick={() => navigation("/nftcategories")}>
            <ViewButton>View All</ViewButton>
          </ViewAllWrapper>
        </HeadingTextcontainer>

        <NftGridContainer>
        <Slider {...settings}>
        <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
           
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> StingRay Rifle </NftNameText>
                <NftNameHash> #1099 </NftNameHash>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 45.32 USD </Pricevalue>
                </PriceWrapper>
                {/* <PriceWrapper>
                    <PriceText OwnedBy> Owned By </PriceText>
                    <Pricevalue> Tyagi </Pricevalue>
                </PriceWrapper> */}
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory common>Common</NftCategory>
             
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Fangs of Fury </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 15.5 USD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory rare>Rare</NftCategory>
         
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Circuit Breaker </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 48MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>
               
              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Launcher </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 2.65MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

            <NftGridWrapper>
              <NftNewArivalWrapper onClick={() => navigation("/nftcategories")}>
                <NftCategory>Legendary</NftCategory>

              </NftNewArivalWrapper>
              <NftNameWrapper>
                <NftNameText> Heavy </NftNameText>
              </NftNameWrapper>

              <PriceButtonContainer>
                <PriceWrapper PriceText>
                  <PriceText > Best price </PriceText>
                  <Pricevalue> 10MLD </Pricevalue>
                </PriceWrapper>
                <ButtonWrapper onClick={() => navigation("/nftcategories")}>
                  <Button>Buy Now</Button>
                </ButtonWrapper>
              </PriceButtonContainer>
            </NftGridWrapper>

          </Slider>
        </NftGridContainer>
      </Container>
    </Root>
  );
};

export default TrendingWeapons;
